import React from 'react';
import { useParams } from 'react-router-dom';

export const PhoneboardDetailPage: React.FC = () => {
  const { id } = useParams();

  return (
    <div>
      <h2 className="text-2xl font-semibold mb-4">폰보드 상세 - {id}</h2>
      <p>폰보드 상세 정보가 여기에 표시됩니다.</p>
    </div>
  );
};